import type { EscritorioResumo } from '@/api/client';

import { FiltroDaLista } from './filtro-da-lista';

interface OrigemFilterBarProps {
  escritorios: EscritorioResumo[];
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  includeSistema?: boolean;
  includeCompartilhados?: boolean;
}

/**
 * De quem é o item: meus, de um dos escritórios, do sistema, compartilhados. Era uma
 * fileira de botões pequenos; virou um filtro da barra da lista
 * (docs/PLANO_BARRA_DE_LISTA.md), com a mesma cara dos demais. Os valores que vão ao
 * backend não mudam; `undefined` = todos.
 */
export function OrigemFilterBar({
  escritorios,
  value,
  onChange,
  includeSistema = false,
  includeCompartilhados = false,
}: OrigemFilterBarProps) {
  const opcoes = [
    ...(includeSistema ? [{ value: 'sistema', label: 'Sistema' }] : []),
    { value: 'meus', label: 'Meus' },
    ...escritorios.map((esc) => ({ value: `escritorio:${esc.id}`, label: esc.nome })),
    ...(includeCompartilhados ? [{ value: 'compartilhados', label: 'Compartilhados' }] : []),
  ];
  return (
    <FiltroDaLista
      eixo="Origem"
      value={value ?? ''}
      onValueChange={(v) => onChange(v || undefined)}
      vazio=""
      rotuloVazio="Todas as origens"
      opcoes={opcoes}
      buscavel={opcoes.length > 8}
    />
  );
}
